import classNames from "classnames";
import { ReactNode } from "react";

export type CircleProps = {
  content: string;
  classname?: string;
  title?: string;
  children?: ReactNode;
};

function Circle({ content, classname, title, children }: CircleProps) {
  return (
    <div
      title={title ?? content}
      className={classNames(
        "flex h-7 w-7 items-center justify-center rounded-full text-sm font-bold",
        classname,
        { "bg-th-primary-900": !classname?.includes("bg-") },
      )}
    >
      <span className="text-center">{children ?? content}</span>
    </div>
  );
}

export default Circle;
